import { CircularProgress, Stack, TextField, Typography } from "@mui/material";
import { useContext, useState } from "react";

import { ApiContext } from "../ApiContext";

import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { ColorScheme } from "../../Themes/ColorScheme";
import BigButton from "../Common/BigButton";

export const ValidationForm = ({ userEmail, switchComponent }) => {
	const [validationId, setValidationId] = useState("");
	const [validating, setValidating] = useState(false);
	const navigate = useNavigate();
	const { t } = useTranslation();

	function deleteAllCookies() {
		let cookies = document.cookie.split(";");
		for (let i = 0; i < cookies.length; i++)
			document.cookie =
				"webapp-token=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/;";
	}

	const handleSuccessfulLogin = async (response) => {
		await deleteAllCookies();
		document.cookie = "webapp-token=" + response.access_token + "; path=/;";
		navigate("/"); // triggers launchInit.js
	};

	const { ApiCall } = useContext(ApiContext);

	const validateNewAccount = (e) => {
		setValidating(true);
		e.preventDefault();

		ApiCall("POST", "code_login", {
			email: userEmail,
			code: validationId
		})
			.then((response) => {
				switchComponent("");
				handleSuccessfulLogin(response);
				setValidating(false);
			})
			.catch(() => {
				setValidationId("");
				setValidating(false);
			});
	};

	const validateCode = (code) => {
		const isValid = code.length === 4 && /^\d+$/.test(code);
		return isValid;
	};

	return (
		<form onSubmit={validateNewAccount} style={{ width: "100%" }}>
			<Stack spacing={3}>
				<Typography sx={{ color: ColorScheme.secondary, fontSize: "14px" }}>
					{t("login.account_activation_label")}
				</Typography>

				<TextField
					placeholder={t("login.account_validation_code")}
					sx={{
						backgroundColor: ColorScheme.lightGrey,
						borderRadius: "5px"
					}}
					id="validation"
					variant="outlined"
					margin="dense"
					fullWidth={true}
					size="small"
					value={validationId}
					onChange={(e) => setValidationId(e.target.value)}
				/>

				<Stack
					style={{ justifyContent: "center", alignItems: "center" }}
				>
					{!validating ? (
						<Stack style={{ width: "100%" }}>
							<BigButton
								text={t("buttons.send")}
								activity={validating}
								borderColor={ColorScheme.primary}
								backgroundColor={ColorScheme.buttonPrimary}
								textColor={ColorScheme.textPrimary}
								width="100%"
								action={validateNewAccount}
								disabled={!validateCode(validationId)}
							/>
						</Stack>
					) : (
						<CircularProgress color="info" />
					)}
				</Stack>
			</Stack>
		</form>
	);
};
